<template>
  <div>
    <b-card class="standardpage border-none">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="aircrafts.icon" class="mr-1"></i>
            <span>{{ aircrafts.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">

            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Description" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="description" :debounce="aircrafts.debounce"
                      placeholder="Description"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!description"
                        @click="description = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="ICAO" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="icaocode" :debounce="aircrafts.debounce" placeholder="ICAO"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!icaocode" @click="icaocode = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="IATA" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="iatacode" :debounce="aircrafts.debounce" placeholder="IATA"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!iatacode" @click="iatacode = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="aircrafts" :icon="aircrafts.icon" :busy="aircrafts.busy"
            :toolbarlibrary="aircrafts.toolbarlibrary" :tools="aircrafts.tools" :badges="aircrafts.badges"
            :fields="aircrafts.fields" :items="aircrafts.items" :limit="aircrafts.limit" :downloaded="aircrafts.downloaded" :showpages="true"
            :offset="aircrafts.offset" :page="aircrafts.page" @load="aircrafts_load" @click="aircrafts_click"
            @changed="aircrafts_click('save', $event)" @select="aircrafts_select">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :selection="aircrafts.selected" :config="cconfig"
          @discard="aircrafts_click('discard')" @go="aircrafts_click('go')"></component>
      </div>
      <b-card-footer class="mt-2 ml-1">
        <div class="text-center">
                    <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
                        <i class="fa fa-cogs mr-2"></i>Setup All
                    </b-button>
                </div>     
      </b-card-footer>

    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import AircraftsEdit from "./Components/Setup_AircraftsEdit";

export default {
  name: "Aircrafts",
  components: { AircraftsEdit },
  watch: {
    async description() {
      await this.aircrafts_load(0);
    },
    async icaocode() {
      await this.aircrafts_load(0);
    },
    async iatacode() {
      await this.aircrafts_load(0);
    },
  },
  data() {
    return {
      description: null,
      icaocode: null,
      iatacode: null,

      aircrafts: {
        title: "Aircrafts",
        icon: "fa fa-plane",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,download,clipboard,add,edit,deleteconfirm",
        toolbarlibrary: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-50px",
          },
          {
            key: "description",
            label: "Description",
            sortable: true,
          },
          {
            key: "iatacode",
            label: "IATA",
            sortable: true,
          },
          {
            key: "icaocode",
            label: "ICAO",
            sortable: true,
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  async mounted() {
    this.accessdenied();

    await this.aircrafts_load();
  },

  methods: {
    accessdenied() {
      this.aircrafts.denied = [];
      if (!this.user.permissions.includes("setup_aircrafts.admin")) {
        this.aircrafts.denied.push("deleteconfirm");
      }
      if (!this.user.permissions.includes("setup_aircrafts.admin")) {
        this.aircrafts.denied.push("add");
        this.aircrafts.denied.push("save");
      }

    },


    async aircrafts_load(offset, limit, page) {
      let state = this.aircrafts;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,

        id: this.id,
        description: this.description,
        icaocode: this.icaocode,
        iatacode: this.iatacode,
        dateformat: "DD/MM/YYYY",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
              query setup_aircrafts(
                $limit: Int
                $offset: Int
                $description: String
                $icaocode: String
                $iatacode: String
                $dateformat: String       
              ) {
                setup_aircrafts(
                  limit: $limit
                  offset: $offset
                  description: $description
                  icaocode: $icaocode
                  iatacode: $iatacode
                  dateformat: $dateformat
                ) {
                  id
                  description
                  icaocode
                  iatacode      
                  rows
                  updated_at
                  updated_by
                }
              }
            `,
          variables,
        });

        // USE LOCAL VARIABLE
     
        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.setup_aircrafts
        } else {
          state.items = response.data.setup_aircrafts;
        }

      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async aircrafts_click(a, ss) {

      let state = this.aircrafts;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.aircrafts_load(0, 0);
          break;
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          await this.aircrafts_load();
          break;
        case "go":
          this.component = null;
          await this.aircrafts_load();
          break;
        case "add":
        case "edit":
          this.component = "AircraftsEdit";
          break;

        case "save":
          this.saveit(ss);
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async aircrafts_select(ss, tools) {

      let state = this.aircrafts;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "download", "clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async saveit(ss) {

      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation setup_aircrafts_save(
                $rows: [setup_aircrafts_input]             
              ) {
                setup_aircrafts_save(rows: $rows) {
                  id
                  description
                  icaocode
                  iatacode      
                }
              }
            `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation setup_aircrafts_delete(
                $rows: [setup_aircrafts_input]
              ) {
                setup_aircrafts_delete(rows: $rows) {
                  id
                }
              }
            `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.aircrafts_load(0);
    },
  },
};
</script>

<style scoped></style>